module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('header-bar'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Big Ideas Map - Coming soon!")]), _vm._v(" "), _c('p', [_vm._v("Share and promote, connect with and contribute to projects and initiatives on the ground in Africa – exchange ideas, and drive change for Africa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-230ef03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Projects.vue
// module id = 683
// module chunks = 1